<template>
    <div class="queue tableStyle">
        <div class="query-row flex">
            <el-form :inline="true" class="demo-form-inline" size="small">
                <el-form-item label="厂商名称：">
                    <el-select v-model="params.company_id" placeholder="请选择" @change="getTableList('query')" clearable>
                        <el-option v-for="(item, index) in allManufactor" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getTableList('query')">查询</el-button>
                </el-form-item>
            </el-form>

            <el-button type="primary" size="small" @click="openDialog">新增配置</el-button>
        </div>
        
        <div class="table">
            <el-table :data="tableData" class="table-border" height="100%">
                <!-- <el-table-column type="index" label="序号"></el-table-column> -->
                <el-table-column label="厂商id" prop="company_id" align="center" width="80"></el-table-column>
                <el-table-column label="厂商名称" prop="company.name"></el-table-column>
                <!-- <el-table-column label="厂商key" prop="key" align="center"></el-table-column>
                <el-table-column label="队列ip" prop="host" align="center"></el-table-column>
                <el-table-column label="端口" prop="port" align="center" width="60"></el-table-column>
                <el-table-column label="vhost" prop="vhost" align="center"></el-table-column> -->
                <el-table-column label="账号" prop="account" align="center"></el-table-column>
                <el-table-column label="密码" prop="password" align="center"></el-table-column>
                <!-- <el-table-column label="设备状态" prop="device_status" align="center"></el-table-column>
                <el-table-column label="充电心跳" prop="charge_heartbeat" align="center"></el-table-column>
                <el-table-column label="充电订单结束" prop="end_order" align="center"></el-table-column>
                <el-table-column label="白名单ip" prop="white_list" align="center"></el-table-column> -->
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" @click="goDetail(scope.row)">
                            详情
                        </el-button>
                        <el-button type="primary" plain size="mini" @click="goEdit(scope.row)">
                            修改
                        </el-button>
                        <el-button type="danger" plain size="mini" @click="goDel(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageFoot flex">
            <div class="tongji">
                统计：共{{total}}个配置
            </div>
            <el-pagination
                layout="total, prev, pager, next, sizes"
                background
                :page-size="params.size"
                :total="total"
                :page-sizes="[20,50,100,200,500,1000]"
                @size-change="sizeChange"
                @current-change="changePage">
            </el-pagination>
        </div>

        <el-dialog
            :title="this.form.id ? '编辑配置' : '新增配置'"
            top="5vh"
            custom-class="dialogRadius"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="closeDialog">
            <el-form ref="form" :model="form" :rules="rules" size="small" label-width="auto">
                <el-form-item label="厂商：" prop="company_id">
                    <el-select v-model="form.company_id" placeholder="请选择" style="width: 100%">
                        <el-option v-for="(item, index) in allManufactor" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="队列IP：" prop="host">
                    <el-input v-model="form.host" placeholder="请输入队列IP"></el-input>
                </el-form-item>
                <el-form-item label="端口号：" prop="port">
                    <el-input v-model="form.port" placeholder="请输入端口号"></el-input>
                </el-form-item>
                <el-form-item label="vhost：" prop="vhost">
                    <el-input v-model="form.vhost" placeholder="请输入vhost"></el-input>
                </el-form-item>
                <el-form-item label="账号：" prop="account">
                    <el-input v-model="form.account" placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="password">
                    <el-input v-model="form.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="设备状态：" prop="device_status">
                    <el-input v-model="form.device_status" placeholder="请输入设备状态"></el-input>
                </el-form-item>
                <el-form-item label="充电心跳：" prop="charge_heartbeat">
                    <el-input v-model="form.charge_heartbeat" placeholder="请输入充电心跳"></el-input>
                </el-form-item>
                <el-form-item label="充电订单结束：" prop="end_order">
                    <el-input v-model="form.end_order" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="白名单IP：" prop="white_list">
                    <el-input v-model="form.white_list" type="textarea" placeholder="请输入白名单IP"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取 消</el-button>
                <el-button size="small" type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            top="5vh"
            :title="detailTitle"
            custom-class="dialogRadius"
            :visible.sync="detailShow"
            width="30%"
            :before-close="closeDetail">
            <el-descriptions :column="1" border>
                <el-descriptions-item label="厂商">
                    {{detail.company_name}}
                </el-descriptions-item>
                <el-descriptions-item label="队列IP">
                    {{detail.host}}
                </el-descriptions-item>
                <el-descriptions-item label="端口号">
                    {{detail.port}}
                </el-descriptions-item>
                <el-descriptions-item label="vhost">
                    {{detail.vhost}}
                </el-descriptions-item>
                <el-descriptions-item label="账号">
                    {{detail.account}}
                </el-descriptions-item>
                <el-descriptions-item label="密码">
                    {{detail.password}}
                </el-descriptions-item>
                <el-descriptions-item label="设备状态">
                    {{detail.device_status}}
                </el-descriptions-item>
                <el-descriptions-item label="充电心跳">
                    {{detail.charge_heartbeat}}
                </el-descriptions-item>
                <el-descriptions-item label="充电订单结束">
                    {{detail.end_order}}
                </el-descriptions-item>
                <el-descriptions-item label="白名单IP">
                    {{detail.white_list}}
                </el-descriptions-item>

            </el-descriptions>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            params:{
                page: 1,
                size: 20,
                company_id: '',
            },
            total: 0,
            allManufactor: [],
            tableData: [],

            dialogVisible: false,
            form: {
                company_id: '',
                host: '',
                port: '',
                vhost: '',
                account: '',
                password: '',
                device_status: '',
                charge_heartbeat: '',
                end_order: '',
                white_list: '',
            },
            rules: {
                company_id: [{required: true, message: '请选择厂商', trigger: 'blur'}],
                host: [{required: true, message: '请输入队列ip', trigger: 'blur'}],
                port: [{required: true, message: '请输入端口号', trigger: 'blur'}],
                vhost: [{required: true, message: '请输入vhost', trigger: 'blur'}],
                account: [{required: true, message: '请输入账号', trigger: 'blur'}],
                password: [{required: true, message: '请输入密码', trigger: 'blur'}],
                device_status: [{required: true, message: '请输入设备状态', trigger: 'blur'}],
                charge_heartbeat: [{required: true, message: '请输入充电心跳', trigger: 'blur'}],
                end_order: [{required: true, message: '请输入充电订单结束', trigger: 'blur'}],
                white_list: [{required: true, message: '请输入白名单ip', trigger: 'blur'}],
            },
            detailShow: false,
            detailTitle: '',
            detail: {
                company_name: '',
                host: '',
                port: '',
                vhost: '',
                account: '',
                password: '',
                device_status: '',
                charge_heartbeat: '',
                end_order: '',
                white_list: '',
            },
        }
    },
    created() {
        this.init();
    },
    methods: {
        init(){
            this.getTableList();
            this.getAllManufactor();
        },
        getTableList(type){
            if(type === 'query'){
                this.params.page = 1;
            }
            this.$http.get(this.common.admin + '/admin/rabbitMQList', {
                params: this.params
            }).then(res => {
                if(res.code === 200){
                    this.tableData = res.data.list;
                    this.total = res.data.total;
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        // 获取所有厂商
        getAllManufactor(){
            this.$http.get(this.common.admin + '/admin/companyAllList', {
                params: {type: 1}
            }).then(res => {
                if(res.code === 200){
                    this.allManufactor = res.data;
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        sizeChange(val){
            this.params.size = val;
            this.getTableList();
        },
        changePage(val){
            this.params.page = val;
            this.getTableList();
        },
        goEdit(data){
            this.$http.get(this.common.admin + '/admin/rabbitMQDetail', {
                params: {id: data.id}
            }).then(res => {
                if(res.code === 200){
                    this.form = res.data;
                    this.openDialog();
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        openDialog(){
            this.dialogVisible = true;
        },
        closeDialog(){
            this.dialogVisible = false;
            this.$refs.form.clearValidate();
            this.form = {
                company_id: '',
                host: '',
                port: '',
                vhost: '',
                account: '',
                password: '',
                device_status: '',
                charge_heartbeat: '',
                end_order: '',
                white_list: '',
            };
        },
        submit(){
            this.$refs.form.validate(v => {
                if(v === true){
                    let url = this.form.id ? '/admin/rabbitMQEdit' : '/admin/rabbitMQAdd';
                    this.$http.post(this.common.admin + url, this.form).then(res => {
                        if(res.code === 200){
                            this.$message.error(this.form.id ? '编辑成功' : '新增成功');
                            this.getTableList('query');
                            this.closeDialog();
                        }else{
                            return this.$message.error(res.msg);
                        }
                    });
                }
            });
        },
        goDel(data){
            this.$confirm(`是否确定删除${data.company.name}的队列配置？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post(this.common.admin + '/admin/rabbitMQDelete', {id: data.id}).then(res => {
                    if(res.code === 200){
                        this.$message.success('删除成功');
                        this.getTableList();
                    }else{
                        return this.$message.error(res.msg);
                    }
                });
            }).catch(() => {});
        },
        goDetail(data){
            this.$http.get(this.common.admin + '/admin/rabbitMQDetail', {
                params: {id: data.id}
            }).then(res => {
                if(res.code === 200){
                    this.detail = res.data;
                    this.detailShow = true;
                    for(let i of this.allManufactor){
                        if(i.id === this.detail.company_id){
                            this.detail.company_name = i.name;
                            this.detailTitle = this.detail.company_name + '详情';
                        }
                    }
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        closeDetail(){
            this.detailShow = false;
            this.form = {
                company_id: '',
                host: '',
                port: '',
                vhost: '',
                account: '',
                password: '',
                device_status: '',
                charge_heartbeat: '',
                end_order: '',
                white_list: '',
            };
        }
    },
}
</script>
<style lang="less" scoped>
    .queue{
        height: 100%;
        .query-row{
            justify-content: space-between;
            align-items: flex-start;
        }

        .table{
            height: calc(100% - 115px);
        }
        .pageFoot{
            align-items: center;
            justify-content: space-between;

            .tongji{
                font-size: 14px;
            }
        }
    }
</style>